<template>
  <div>
    <b-form-group
      :label="$t('custom_forms.hint')"
      label-for="hint"
    >
      <b-form-input
        id="hint"
        v-model="hint"
        @input="onInputChange"
      />
    </b-form-group>
    <b-form-group
      :label="$t('custom_forms.maxlength')"
      label-for="maxLength"
    >
      <b-form-input
        id="maxLength"
        v-model="maxLength"
        @input="onlyInteger"
        class="w-50"
        step="1"
        type="number"
        min="1"
      />
    </b-form-group>
    <b-form-group
      :label="$t('custom_forms.read_only')"
      label-for="readOnly"
    >
      <b-form-checkbox
        id="readOnly"
        v-model="readOnly"
        :checked="false"
        switch
        @change="onInputChange"
      />
    </b-form-group>
    <b-form-group
      :label="$t('custom_forms.type_number')"
      label-for="isNumber"
    >
      <b-form-checkbox
        id="isNumber"
        v-model="isTypeNumber"
        :checked="false"
        switch
        @change="onInputChange"
      />
    </b-form-group>
  </div>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({data: []}),
    },
    config: Object,
  },
  setup(props, {emit}) {
    const hint = ref("")
    const maxLength = ref("")
    const readOnly = ref(false)
    const isTypeNumber = ref(false)

    onMounted(async () => {
      maxLength.value = props.data?.data?.[0]?.maxLength
      hint.value = props.data?.data?.[0]?.hint
      readOnly.value = props.data?.data?.[0]?.readOnly
      isTypeNumber.value = props.data?.data?.[0]?.isTypeNumber
    });

    function onInputChange() {
      const payload = {
        maxLength: maxLength.value,
        hint: hint.value,
        readOnly: readOnly.value,
        isTypeNumber: isTypeNumber.value,
      }

      emit("update:data", {
        data: [{...payload}],
      });
    }

    function onlyInteger() {
      if (!maxLength.value) return;
      if (maxLength.value.includes('.')) {
        maxLength.value = maxLength.value.replace(/\./g, '');
      }
      if (maxLength.value.includes('-')) {
        maxLength.value = maxLength.value.replace(/-/g, '');
      }
      const num = Number(maxLength.value);
      if (!num || num <= 0) {
        maxLength.value = 1;
      }
      onInputChange()
    }

    return {
      hint,
      maxLength,
      readOnly,
      isTypeNumber,
      onInputChange,
      onlyInteger
    };
  },
};
</script>
